<template>
	<landing-page-template3 />
</template>

<script>
import LandingPageTemplate3 from '@/views/JnsLandingPages/templates/LandingPageTemplate3.vue';

export default {
	name: 'AmPmLandingPage',
	components: { LandingPageTemplate3 },
};
</script>

<style scoped>

</style>
